<script>
	import { PUBLIC_PATH } from '$env/static/public';
	export let featuresData;
</script>

<section
	id="features_container"
	aria-label="Features"
	class="relative overflow-hidden bg-background-alt"
>
	<!-- Chevrons -->
	<img
		src={`${PUBLIC_PATH}/images/chevron-filled.svg`}
		alt=""
		class="pointer-events-none absolute left-0 top-0 z-0 h-[50dvw] max-h-[15rem] w-auto rotate-180 object-contain lg:h-full lg:max-h-full"
	/>
	<img
		src={`${PUBLIC_PATH}/images/chevron-filled.svg`}
		alt=""
		class="pointer-events-none absolute right-0 top-0 z-0 h-[50dvw] max-h-[15rem] w-auto object-contain lg:h-full lg:max-h-full"
	/>

	<div
		class="absolute inset-x-0 top-0 z-0 h-[15.625rem] bg-gradient-to-b from-[rgba(59,91,217,0.10)] to-transparent lg:h-[21.25rem]"
	></div>

	<div class="relative mx-auto max-w-8xl px-padding_lg py-8 lg:px-3 lg:py-16 z-10">
		<div class="mx-auto max-w-[61.25rem] text-center">
			<h2
				class="text-[1.1875rem] font-semibold leading-[1.5rem] text-black-key lg:font-barlow lg:text-[2.5rem] lg:leading-[3.5rem]"
			>
				{featuresData.title}
			</h2>
			<p
				class="mx-auto mt-padding_xsm max-w-[17.125rem] body_small tracking-[0.0015rem] text-body lg:mt-padding_lg lg:max-w-[51.25rem] lg:body_large"
			>
				{featuresData.description}
			</p>
		</div>

		<div
			class="mt-padding_lg flex flex-col items-center gap-padding_lg lg:mt-space_40 lg:flex-row lg:gap-padding_xxlg px-6 lg:px-[280px]"
		>
			{#each featuresData.items as feature}
				<!-- Card -->
				<div
					class="flex w-full flex-col items-center rounded-shape-corner_md border border-border bg-background-alt px-padding_lg py-padding_xlg shadow-elevation_level3 lg:px-padding_xlg lg:w-1/3 lg:py-padding_xxlg"
				>
					<div class={feature.imageContainerClass}>
						<img
							class={feature.imageClass}
							src={`${PUBLIC_PATH}/${feature.image}`}
							alt={feature.altText}
						/>
					</div>
					<div class="mt-padding_xsm text-center lg:mt-padding_sm">
						<div class={feature.titleClass}>{feature.title}</div>
						<div class="mt-padding_xxsm body_default text-body">{feature.subtitle}</div>
					</div>
				</div>
			{/each}
		</div>
	</div>
</section>
